import { ArrangementType, Format } from '../models/enums';
import { ChannelType } from '../models/ichannel';
import { ECG_CONSTANTS } from '../utils/ecg-constants';
import { ILayerViewModel, ILayout } from '../models/interfaces';
import { RelocateComposer } from './relocateComposer';

export class CabreraComposer extends RelocateComposer<Format> {
    // constructor

    constructor(layout: ILayout) {
        super(layout, Format.standard);
    }

    public isChanged() {
        return this.changeDetection.isChanged(this.layout.ecgState.chartState.format);
    }

    // protected functions

    protected onUpdate(layer: ILayerViewModel) {
        const traceOrder =
            this.layout.ecgState.chartState.format != Format.cabrera
                ? ECG_CONSTANTS.CHANNELS_STANDARD_ORDER
                : ECG_CONSTANTS.CHANNELS_CABRERA_ORDER;

        let swapper = (sourceIndex: number, targetIndex: number) => {
            let tmp = layer.traces[targetIndex];
            layer.traces[targetIndex] = layer.traces[sourceIndex];
            layer.traces[sourceIndex] = tmp;
        };

        if (this.layout.ecgState.chartState.arrangement != ArrangementType.SixXOnePrecordial) {
            traceOrder.forEach((name, index) => {
                const traceIndex = layer.traces.findIndex((trace) => trace.channel?.type === name);
                if (traceIndex !== -1) {
                    swapper(index, traceIndex);
                }
            });
        }

        this.updateAVR(layer);

        super.onUpdate(layer);
    }

    // private functions

    private updateAVR(layer: ILayerViewModel) {
        const avr = layer.traces.find((avrTrace) => avrTrace.channel?.type === ChannelType.LEAD_AVR);
        if (!avr) {
            return;
        }

        if (this.layout.ecgState.chartState.format == Format.standard && avr.step?.title.startsWith('-')) {
            avr.channel?.samples.forEach((sample) => (sample.value = -sample.value));
            if (!!avr.step) avr.step.title = avr.step.title.replace('-', '');
        } else if (this.layout.ecgState.chartState.format == Format.cabrera && !avr.step?.title.startsWith('-')) {
            avr.channel?.samples.forEach((sample) => (sample.value = -sample.value));
            if (!!avr.step) avr.step.title = '-' + avr.step.title;
        }

        avr.updateTrace();
    }
}
